import styled from '@emotion/styled';

export const StyledResponsivePadding = styled.div`
  padding: 56.25% 0 0 0;
  position: relative;
`;

export const StyledResponsiveWrapper = styled.div`
  height: 100%;
  left: 0;
  position: absolute !important;
  top: 0;
  width: 100%;
`;

export const StyledEmbed = styled.div`
  height: 100%;
  width: 100%;

  iframe {
    visibility: hidden;
  }
`;
